'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildWelcomeMessage = buildWelcomeMessage;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _immutable = require('immutable');

var _Message = require('conversations-schema/records/Message');

var _Message2 = _interopRequireDefault(_Message);

var _TargetingRule = require('conversations-schema/records/TargetingRule');

var _TargetingRule2 = _interopRequireDefault(_TargetingRule);

var _buildChatHeadingConfigFromJS = require('conversations-schema/chat-heading-config/builders/buildChatHeadingConfigFromJS');

var _buildClientTriggers = require('conversations-schema/client-triggers/factories/buildClientTriggers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildWelcomeMessage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var clientTriggersData = (0, _get2.default)('clientTriggers', data);
  var targetingRulesData = (0, _get2.default)('targetingRules', data);
  var chatHeadingConfigData = (0, _get2.default)('chatHeadingConfig', data);

  var messageRecordInstance = (0, _Message2.default)((0, _immutable.fromJS)(data));

  return messageRecordInstance.merge({
    clientTriggers: (0, _buildClientTriggers.buildClientTriggers)(clientTriggersData),
    targetingRules: (0, _immutable.List)(targetingRulesData).map(_TargetingRule2.default),
    chatHeadingConfig: (0, _buildChatHeadingConfigFromJS.buildChatHeadingConfigFromJS)(chatHeadingConfigData)
  });
}